import React from 'react';
import { Stack, Typography, Tooltip, IconButton, CircularProgress } from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';

const PanelHeader = ({ title, onRefresh, loading, refreshTooltip }) => {
  return (
    <Stack 
      direction="row" 
      alignItems="center" 
      justifyContent="space-between" 
      sx={{ mb: 0.7 }} // Increased margin bottom for better breathing room
    >
      <Typography variant="h6" sx={{ fontWeight: 600 }}>
        {title}
      </Typography>

      <Tooltip title={refreshTooltip}>
        <span>
          <IconButton 
            onClick={onRefresh} 
            disabled={loading}
            size="small" // Standardized size for action buttons
          >
            {loading ? <CircularProgress size={18} /> : <RefreshIcon fontSize="small" />}
          </IconButton>
        </span>
      </Tooltip>
    </Stack>
  );
};

export default PanelHeader;